import getAppRoot from '../../../utils/getAppRoot';
import { Models } from '../../../App';
import { SchedulingQueryParams } from '../../constants';
import { isUnscheduledView, View } from '../../../../../components/scheduling/ViewMenu';
import { resolveStoredScheduledView } from '../../../../../helpers/getSelectedView';

const viewValidator = (self: Models['router'], queryParams: any) => {
  const view = queryParams.get(SchedulingQueryParams.VIEW) as View | null;

  // Missing or unknown view: leave it for the tab-matches-date reaction in
  // App.ts to set once route data has loaded. Setting a fallback here would
  // race that reaction and risk landing on the wrong tab.
  if (!view || !Object.values(View).includes(view)) {
    return {};
  }

  // Organizations without the unscheduled order tray (synced workspaces, and the
  // orders-first experiment's treatment arm) can still arrive on an unscheduled
  // view by deep link, bookmark, or history navigation — their view selector has
  // no option to get back out, so rewrite it to their stored Scheduled sub-view.
  if (isUnscheduledView(view) && !getAppRoot(self).ui.canViewUnscheduledViews) {
    return { [SchedulingQueryParams.VIEW]: resolveStoredScheduledView() };
  }

  return {};
};

export default viewValidator;
